/* eslint-disable react/prop-types */
/* eslint-disable react/no-unknown-property */
import React from 'react';
import { useSelector } from 'react-redux';
import logo from '../assets/images/logo.png';

function Navbar({ setShowHomePage, setShowCartPage }) {
  // Getting data from redux store
  const cartItems = useSelector(state => state.cartItems);
  // Calculating total number of the cart items
  const totalCartItems = cartItems.reduce(function (prevValue, obj) {
    return prevValue + obj.cartQuantity;
  }, 0);
  const homePageHandler = e => {
    e.preventDefault();
    setShowHomePage(true);

    setShowCartPage(false);
  };
  const cartPageHandler = e => {
    e.preventDefault();
    setShowHomePage(false);

    setShowCartPage(true);
  };

  return (
    <nav className="bg-[#171C2A] py-4">
      <div className="navBar">
        <a onClick={homePageHandler} href="./">
          <img src={logo} alt="LWS" className="max-w-[140px]" />
        </a>

        <div className="flex gap-4">
          <a
            onClick={homePageHandler}
            href="./"
            className="navHome"
            id="lws-home"
          >
            {' '}
            Home{' '}
          </a>
          <a
            onClick={cartPageHandler}
            href="./card-details"
            className="navCart"
            id="lws-cart"
          >
            <i className="text-xl fa-sharp fa-solid fa-bag-shopping"></i>
            <span id="lws-totalCart">{totalCartItems}</span>
          </a>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
